const RentCycleConstants = {
    DETAIL_HEADER_TEXT: 'Market Rent Cycle Details',
    POPULATION: 'Population',
    OVERALL_OFFICE_MARKET_SIZE: 'Overall CBD Office Market Size',
    KEY_SUBMARKETS: 'Prime Office Submarkets',
    OFFICE_DATA: 'Prime Office Market Data',
    RENT_CYCLE_POSITION: 'Prime Rent Cycle Position',
    OVERALL_VACANCY: 'Overall CBD Office Vacancy',
    OVERALL_RENT_CHANGE: 'Prime CBD Office Rent Change',
    OVERALL_RENT_CHANGE_YOY: '(Y-o-Y)',
    HISTORICAL_RENT_CYCLE_POSITIONS: 'Historical Rent Cycle Positions',
    ADD_COMPARISON_MARKET: 'Add Comparison Market',
    LEARN_MORE_ABOUT_CBRE: 'Learn more about CBRE ',
    DETAIL_FOOTER_TEXT: 'Area Represented in Stock and Vacancy Data: ',
    DETAIL_FOOTER_TEXT_AMERICAS_EMEA: 'Prime Rent Area Represented On Cycle: ',
    DETAIL_FOOTER_TEXT_APAC: 'Class A Rent Area Represented On Cycle: ',
    DETAIL_FOOTER_TEXT_4: 'Area Represented on Chart: ',
    DETAIL_FOOTER_TEXT_5: 'Area Represented on Cycle: ',
    COMPARISON_FOOTER_TEXT: '- area represented in stock and vacancy data: ',
    COMPARISON_FOOTER_AMERICAS_EMEA: ' prime rent area represented on cycle: ',
    COMPARISON_FOOTER_TEXT_APAC: ' class A rent area represented on cycle: ',
    COMPARISON_FOOTER_TEXT_DEFAULT: ' area represented on cycle: ',
    COMMENTARY: 'Commentary',
    COMPARISON_HEADER_TEXT: 'Compare Markets',
    ADD_COMPARISON_SUB_TEXT: 'Select the market you would like to compare.',
    CANCEL: 'Cancel'
}

export default RentCycleConstants;